import type { ReactNode } from 'react';

export interface Metric {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  /** Ноль — приглушённо: цвет отмечает исключение, а не факт */
  dim?: boolean;
  /** Вышло за порог — красным `.od` (кит): «Ждут дольше 60 мин», «Без движения» */
  over?: boolean;
}

/**
 * Ряд цифр (кит v2.11): `sum` — паспорт объекта на его обзоре (26),
 * `slice` — срез по фильтрам раздела (20). Героев на карточках нет.
 */
export function MetricRow({ variant, items, className }: { variant: 'sum' | 'slice'; items: Metric[]; className?: string }) {
  if (!items.length) return null;
  return (
    <div className={['mets', variant, className].filter(Boolean).join(' ')}>
      {items.map((m) => (
        <div className="met" key={m.label}>
          <div className="l">{m.label}</div>
          <div className={['v num', m.dim ? 'dim' : '', m.over ? 'od' : ''].filter(Boolean).join(' ')}>{m.value}</div>
          {m.sub ? <div className="s">{m.sub}</div> : null}
        </div>
      ))}
    </div>
  );
}
